import {get, writable} from "svelte/store";
import {actualiza, cargaUno, crea} from "../Api/grupos";

const estadoInicial = {
  cargando: true,
  error: null,
  grupo: null
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: (id) => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 300);

    store.update(() => estadoInicial);

    cargaUno(id)
        .then(grupo => store.update(valor => ({...valor, grupo})))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  actualizaCampo: (campo, valor) => {
    store.update(estado => ({
      ...estado,
      grupo: {
        ...estado.grupo,
        [campo]: valor
      }
    }));
  },
  nuevo: () => {
    store.set({
      cargando: false,
      error: null,
      grupo: {
        descripcion: '',
        nombre: '',
        grupo: '',
        color: '',
        activo: '',
        horas: [],
        duracion: 0
      }
    });
  },
  guarda: () => {
    const grupo = get(store).grupo;

    const promesa = grupo.id ? actualiza(grupo) : crea(grupo);
    return promesa
        .then(grupo => store.update(valor => ({...valor, error: false, grupo})))
        .catch(error => store.update(valor => ({...valor, error})));
  }
}